<uilab-mat-card appearance="outlined" direction="column">
    <div
        class="card-preview"
        uilab-mat-card-image
        [style.background-color]="previewBackgroundColor"
    >
        <ng-content select="[token-card-preview]"></ng-content>
    </div>

    <uilab-mat-card-header>
        <uilab-mat-card-title>{{ label }}</uilab-mat-card-title>
    </uilab-mat-card-header>

    <uilab-mat-card-content>
        <ng-content select="[token-card-snippets]"></ng-content>
    </uilab-mat-card-content>
</uilab-mat-card>
